import Vue from 'vue';
import VueRouter, { Route } from 'vue-router';
import Layout from '@/layout/index.vue';
import Home from '@/views/Home.vue';
import { getToken } from '@/utils/cookies';
import { UserModule } from '../store/modules/user';
import { Role } from '@/api/types';

Vue.use(VueRouter);

const routes = [
  {
    path: '/',
    name: 'Home',
    component: Home,
    redirect: '/redact',
  },
  {
    path: '/login',
    name: 'Login',
    component: () => import(/* webpackChunkName: "login" */ '@/views/Login.vue'),
  },
  {
    path: '/cb',
    name: 'JAccountCallback',
    component: () => import(/* webpackChunkName: "j-account-callback" */ '@/views/JAccountCB.vue'),
  },
  {
    path: '/menuEdit',
    name: 'MenuEdit',
    redirect: '/menuEdit/index',
    component: Layout,
    meta: {
      title: '菜单编辑',
    },
    children: [
      {
        path: 'index',
        name: 'MenuEditIndex',
        component: () =>
          import(/* webpackChunkName: "menu-edit" */ '@/views/MenuEdit/MenuEdit.vue'),
      },
    ],
  },
  {
    path: '/banner',
    name: 'Banner',
    redirect: '/banner/list',
    component: Layout,
    meta: {
      title: '海报管理',
    },
    children: [
      {
        path: 'list',
        name: 'BannerList',
        component: () => import(/* webpackChunkName: "banner-list" */ '@/views/Banner/List.vue'),
        meta: {
          title: '分组管理',
        },
      },
      {
        path: 'create',
        name: 'BannerCreate',
        component: () =>
          import(/* webpackChunkName: "banner-create" */ '@/views/Banner/Create.vue'),
        meta: {
          title: '添加分组',
        },
      },
      {
        path: 'detail',
        name: 'BannerDetail',
        component: () =>
          import(/* webpackChunkName: "banner-detail" */ '@/views/Banner/Detail.vue'),
        meta: {
          title: ({ query }: Route) => query.name || '分组详情',
        },
      },
    ],
  },
  {
    path: '/account',
    name: 'Account',
    redirect: '/account/list',
    component: Layout,
    meta: {
      superadminRequired: true,
      title: '用户管理',
    },
    children: [
      {
        path: 'list',
        name: 'AccountList',
        component: () => import(/* webpackChunkName: "account-list" */ '@/views/Account/List.vue'),
      },
      {
        path: 'create',
        name: 'AccountCreate',
        component: () =>
          import(/* webpackChunkName: "account-create" */ '@/views/Account/Create.vue'),
        meta: {
          title: '创建用户',
        },
      },
      {
        path: 'edit/:id',
        name: 'Account Edit',
        component: () => import(/* webpackChunkName: "account-edit" */ '@/views/Account/Edit.vue'),
        meta: {
          title: '编辑用户',
        },
      },
    ],
  },
  {
    path: '/profile',
    component: Layout,
    meta: {
      title: '个人信息编辑',
    },
    children: [
      {
        path: '',
        component: () =>
          import(/* webpackChunkName: "redact-profile" */ '@/views/Redact/Profile.vue'),
      },
    ],
  },
  {
    path: '/activity',
    component: Layout,
    meta: {
      title: '活动日历',
    },
    children: [
      {
        path: '',
        name: 'Activity Calendar',
        component: () =>
          import(/* webpackChunkName: "activity-calendar" */ '@/views/ActivityCalendar.vue'),
      },
    ],
  },
  {
    path: '/redact',
    name: 'Redact',
    redirect: '/redact/tree',
    component: Layout,
    meta: {
      title: '页面编辑',
    },
    children: [
      {
        path: 'tree',
        name: 'RedactTree',
        component: () => import(/* webpackChunkName: "redact-tree" */ '@/views/Redact/Tree.vue'),
      },
      {
        path: 'htmlPage',
        name: 'HtmlPage',
        meta: {
          title: '图文编排',
        },
        component: () =>
          import(/* webpackChunkName: "redact-htmlpage" */ '@/views/Redact/HtmlPage/Layout.vue'),
      },
      {
        path: 'listPage',
        name: 'ListPage',
        meta: {
          title: '列表编辑',
        },
        component: () =>
          import(/* webpackChunkName: "redact-listpage" */ '@/views/Redact/ListPage/Layout.vue'),
      },
    ],
  },
];

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes,
});

router.beforeEach((to, from, next) => {
  if (to.path !== '/login' && to.path !== '/cb') {
    if (!getToken()) {
      return next('/login');
    }
  }

  // 非超级管理员用户进入特权页面时跳转到首页
  if (
    (to.meta?.superadminRequired || to.matched[0].meta.superadminRequired) &&
    UserModule.role !== Role.SUPERADMIN
  ) {
    return next('/');
  }
  next();
});

export default router;
